import { property, pipe, contains } from 'lodash/fp';
import { isEmpty, reduce } from 'lodash';

// 'session.viewer.user.roles'
export const hasRole = (role, rolePath) => pipe(property(rolePath), contains(role));

export const allowAccess = (user, allowedRoles) => {
  if (!isEmpty(allowedRoles.matchAll)) {
    return reduce(
      allowedRoles.matchAll,
      (acc, role) => {
        return acc && hasRole(role, 'roles')(user);
      },
      true
    );
  }
  return reduce(
    allowedRoles.matchAny,
    (acc, role) => {
      return acc || hasRole(role, 'roles')(user);
    },
    false
  );
};
